import templateUrl from './regulator-edit-form.html';

export default {
  templateUrl,
  transclude: {
    actionButtons: '?actionButtons'
  },
  bindings: {
    regulator: '<',
    dialogTitle: '@',
    submitTitle: '@',
    onRegulatorChanged: '&'
  },
  controller: class RegulatorEditFormComponent {
    constructor(EventEmitter) {
      'ngInject';

      Object.assign(this, { EventEmitter });
    }

    onSubmit() {
      this.onRegulatorChanged(
        this.EventEmitter({
          regulator: this.regulator
        })
      );
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/admin/regulator/regulator-edit-form/regulator-edit-form.component.js